// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import App from "./App.jsx";
import theme from "./theme";

import { AuthProvider } from "./context/AuthProvider.jsx";
import { SeasonProvider } from "./context/SeasonContext.jsx";

import "./index.css";
import "./print.css";   // ⭐ THIS FIXES YOUR PRINTING

console.log("[main] 🚀 Bootstrapping application...");

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />

        <BrowserRouter>
          <AuthProvider>
            <SeasonProvider>
              <App />
            </SeasonProvider>
          </AuthProvider>
        </BrowserRouter>

      </ChakraProvider>
    </HelmetProvider>
  </React.StrictMode>
);

console.log("[main] ✅ Render complete — root mounted");
